import React, { useCallback, useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeIsvFixedFeeAmount: (value: Nullable<number>) => void;
}

const IsvFixedFeeAmountField: React.FC<IProps> = ({ changeIsvFixedFeeAmount }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterIsvFixedFeeAmount') }], [t]);

	const handleChange = useCallback(
		(value: Nullable<number>) => {
			changeIsvFixedFeeAmount(value);
		},
		[changeIsvFixedFeeAmount],
	);

	return (
		<FormInput
			testId="IsvFixedFeeAmountField"
			name="isvFixedFeeAmount"
			label="isvFixedFeeAmountLabel"
			type="number"
			onChangeNumber={handleChange}
			validationRules={validationRules}
			min={0}
			precision={0}
		/>
	);
};

export default React.memo(IsvFixedFeeAmountField);
